import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Grid } from '@chakra-ui/react';
import history from '../../../history';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../components/button/button';
import LoaderOverlay from '../../../components/loader-overlay/loader-overlay';
import { ModalComponent } from '../../../components/Modal/modal';
import { styles } from '../dictionary-styles';
const RequestTypes = {
    PUBLISH: 'Publishing',
    UPLOAD: 'Uploading',
    UPDATE: 'Updating',
    DELETE: 'Deleting'
};
export const RequestInProgress = (props)=>{
    const { onMount, onUnmount, requestResponse } = props;
    useEffect(()=>{
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const requestIds = params.getAll('requestId');
        onMount(requestIds);
        return ()=>{
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const requestIds = params.getAll('requestId');
            onUnmount(requestIds);
        };
    // eslint-disable-next-line
    }, []);
    const errors = requestResponse.errors?.map((error)=>{
        return /*#__PURE__*/ _jsx("p", {
            children: error.errorMessage
        });
    });
    const dispatch = useDispatch();
    const handleAction = ()=>{
        history.goBack();
    };
    const dictionaryName = requestResponse.dictionaryName ?? 'dictionary';
    const requestType = requestResponse.requestType ?? '';
    const action = requestType in RequestTypes ? RequestTypes[requestType] : RequestTypes.UPDATE;
    const classes = styles();
    return /*#__PURE__*/ _jsx(Box, {
        children: /*#__PURE__*/ _jsx("div", {
            children: requestResponse.errorStatus ? /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(ModalComponent, {
                    size: 'xl',
                    isOpen: true,
                    handleClose: ()=>{},
                    modalHeader: /*#__PURE__*/ _jsx("div", {
                        children: "Error"
                    }),
                    modalContent: /*#__PURE__*/ _jsx("div", {
                        style: {
                            padding: '16px'
                        },
                        children: errors
                    }),
                    modalFooter: /*#__PURE__*/ _jsx(Button, {
                        label: 'Go Back',
                        onClick: handleAction
                    })
                })
            }) : /*#__PURE__*/ _jsx(Grid, {
                sx: classes.loaderWrapper,
                children: /*#__PURE__*/ _jsx(LoaderOverlay, {
                    loadingMsg: `${action} ${dictionaryName}...`
                })
            })
        })
    });
};
